import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/app/en/about/@awards/page.tsx");
